<div class="main-group">
	<!--			-->
	<!-- Item Count -->
	<!--			-->
	<div class="main-group-item">
		<div class="main-group-item-center">
			<label class="label-item-total">{{ ItemsChangedMessage }}</label>
		</div>
	</div>

	<!-- 				  -->
	<!-- Printer Selector -->
	<!-- 				  -->
	<div class="main-group-item">
		<div class="selector-item">
			<div>
				<label class="label-item">Card Printer</label>
			</div>

			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select
					class="form-control"
					name="PrinterSelector"
					style="font-size: smaller"
					[(ngModel)]="SelectedPrinter"
					(ngModelChange)="onPrinterChange($event)"
				>
					<option *ngFor="let r of lstPrinter" [ngValue]="r">{{ r.PrinterName }} - {{ r.ScanStation }}</option>
				</select>
			</div>
		</div>
	</div>

	<!--	   -->
	<!-- Notes -->
	<!--	   -->
	<div class="main-group-item">
		<div>
			<label class="label-item">Note:</label>
			<label style="margin-left: 10px"
				>Any print queue records that were selected that did not have the status of [Review Pending] have been prefiltered.</label
			>
		</div>
	</div>

	<!--				-->
	<!-- Error Message  -->
	<!--				-->
	<div class="main-group-item" [style.display]="ErrorMessage != '' ? 'block' : 'none'">
		<div>
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" [disabled]="isBusy == true" (click)="onSetPrinter()">Ok</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
